<h1 id="title" class="title">Change password</h1>
<p class="sub-title">Please set a new password</p>

<form [formGroup]="form" aria-labelledby="title">
	<div class="form-control-group">
		<label class="label">Old Password:</label>
		<input nbInput
			type="password"
			name="oldPassword"
			placeholder="Password"
			fullWidth
			formControlName="oldPassword"
			[status]="form.controls['oldPassword'].dirty ? (form.controls['oldPassword'].invalid  ? 'danger' : 'success') : ''"
			[required]="true"
			[minlength]="6"
			[maxlength]="255"
			[attr.aria-invalid]="form.controls['oldPassword'].invalid && form.controls['oldPassword'].touched ? true : null">
		<ng-container *ngIf="form.controls['oldPassword'].invalid && form.controls['oldPassword'].touched">
			<p class="error-message" *ngIf="form.controls['oldPassword'].errors?.required">
				Password is required!
			</p>
			<p class="error-message" *ngIf="form.controls['oldPassword'].errors?.minlength || form.controls['oldPassword'].errors?.maxlength">
				Password should contains
				from 6
				to 255
				characters
			</p>
		</ng-container>
	</div>
	<div class="form-control-group">
		<label class="label">New Password:</label>
		<input nbInput
			type="password"
			name="newPassword"
			placeholder="New Password"
			fullWidth
			formControlName="newPassword"
			[status]="form.controls['newPassword'].dirty ? (form.controls['newPassword'].invalid  ? 'danger' : 'success') : ''"
			[required]="true"
			[minlength]="6"
			[maxlength]="255"
			[attr.aria-invalid]="form.controls['newPassword'].invalid && form.controls['newPassword'].touched ? true : null">
		<ng-container *ngIf="form.controls['newPassword'].invalid && form.controls['newPassword'].touched">
			<p class="error-message" *ngIf="form.controls['newPassword'].errors?.required">
				Password is required!
			</p>
			<p class="error-message" *ngIf="form.controls['newPassword'].errors?.minlength || form.controls['newPassword'].errors?.maxlength">
				Password should contains
				from 6
				to 255
				characters
			</p>
		</ng-container>
	</div>

	<div class="form-control-group">
		<label class="label">Confirm Password:</label>
		<input nbInput
			type="password"
			name="newPasswordConfirm"
			placeholder="Confirm Password"
			fullWidth
			formControlName="newPasswordConfirm"
			[status]="form.controls['newPasswordConfirm'].dirty ? (form.controls['newPasswordConfirm'].invalid || form.controls['newPassword'].value != form.controls['newPasswordConfirm'].value  ? 'danger' : 'success') : ''"
			[required]="true"
			[attr.aria-invalid]="form.controls['newPasswordConfirm'].invalid && form.controls['newPasswordConfirm'].touched ? true : null">
		<ng-container *ngIf="form.controls['newPasswordConfirm'].invalid && form.controls['newPasswordConfirm'].touched">
			<p class="error-message" *ngIf="form.controls['newPasswordConfirm'].errors?.required">
				Password confirmation is required!
			</p>
			<p class="error-message" *ngIf="form.controls['newPassword'].value != form.controls['newPasswordConfirm'].value && !form.controls['newPasswordConfirm'].errors?.required">
				Password does not match the confirm form.controls['password'].
			</p>
		</ng-container>
	</div>

	<nb-alert *ngIf="!!errorMessage" outline="danger" role="alert">
		<p class="alert-title"><b>{{ 'Errors.ResetPasswordErrorMessage' | translation }}</b></p>
		<p>
			{{errorMessage}}
		</p>
	</nb-alert>

	<nb-alert *ngIf="!!successMessage" outline="success" role="alert">
		<p class="alert-title"><b>Hooray!</b></p>
		<p>
			{{successMessage}}
		</p>
	</nb-alert>

	<!-- <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
		<p class="alert-title"><b>{{ 'Errors.ResetPasswordErrorMessage' | translation }}</b></p>
		<ul class="alert-message-list">
			<li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
		</ul>
	</nb-alert>

	<nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
		<p class="alert-title"><b>Hooray!</b></p>
		<ul class="alert-message-list">
			<li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
		</ul>
	</nb-alert> -->

	<button nbButton
			status="success"
			fullWidth
			[disabled]="form.invalid"
			(click)="resetPassword()">
		Change password
	</button>
</form>

<section class="sign-in-or-up" aria-label="Sign in or sign up">
  <p><a class="text-link" routerLink="../login">Back to Log In</a></p>
  <!-- <p><a class="text-link" routerLink="../register">Register</a></p> -->
</section>
